import React from "react";
import collections from "../css/collections.css";
import new_collections from "./Assets/new_collections";
import Items from "./Items";
const NewCollections = () => {
  return (
    <div style={collections} className="collections">
      <h1>NEW COLLECTIONS</h1>
      <hr />
      <div className="existing">
        {new_collections.map((item, i) => {
          return (
            <Items
              key={i}
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          );
        })}
      </div>
    </div>
  );
};

export default NewCollections;
